<template>
	<main class="height-100dvh formobile">
		<header class="mob-back-header">
			<img
				class="mr-3"
				@click="backToKanban()"
				src="../../assets/mobile/assprog/mobileBackArrow.svg"
				alt=""
			/>
			Give Feedback
		</header>
		<main class="become-panel-container w-100">
			<div class="mobjd-applied-top mobjd-jobdetails">
				<div class="giveFdbk-overflow">
					<section class="p-1 d-flex flex-column gap-2">
						<div class="giveFdbk-head">
							Recommendation<span class="asterik">*</span>
						</div>

						<div
							class="allocateradios d-flex align-items-center flex-wrap givef-gap"
							:class="{ 'recomendation-error': $v.selectedValue.$error }"
						>
							<b-form-radio-group v-model="$v.selectedValue.$model">
								<b-form-radio value="S">Select</b-form-radio>
								<b-form-radio value="R">Reject</b-form-radio>
								<b-form-radio value="DNA">No Show</b-form-radio>
							</b-form-radio-group>
						</div>
					</section>

					<section class="p-1 d-flex flex-column gap-1 mt-2">
						<div class="giveFdbk-textarea-head">
							Remarks<span class="asterik">*</span>
						</div>

						<b-form-textarea
							placeholder="Enter"
							class="giveFdbk-textarea w-100"
							:class="{ error: $v.formData.recommendationComments.$error }"
							rows="3"
							no-resize
							v-model="$v.formData.recommendationComments.$model"
						>
						</b-form-textarea>
					</section>

					<hr class="hr-back my-2" />

					<section
						class="p-1 d-flex flex-column gap-2 mt-3 extp-basicinfomartion"
					>
						<div id="hideinmobile" class="giveFdbk-head">
							Basic Info<span class="asterik">*</span>
						</div>

						<div class="d-flex flex-column gap-3 w-100">
							<div class="d-flex givef-flex gap-2 w-100">
								<div class="w-40 giveFdbk-basic-head givef-w-100">
									Candidate Name
								</div>
								<div class="givef-w60">
									<b-form-input
										class="w-100"
										disabled
										placeholder="Candidate Name"
										:value="
											formData.basicInfo.name
												? formattedData(formData.basicInfo.name)
												: ''
										"
									>
									</b-form-input>
								</div>
							</div>

							<div class="d-flex givef-flex gap-2 w-100">
								<div class="w-40 giveFdbk-basic-head givef-w-100">
									Evaluation Date
								</div>
								<div class="givef-w60">
									<b-form-input
										class="w-100"
										disabled
										placeholder="Evaluation Date"
										:value="evaluationDate()"
									>
									</b-form-input>
								</div>
							</div>

							<div class="d-flex givef-flex gap-2 w-100">
								<div class="w-40 giveFdbk-basic-head givef-w-100">
									Panel Name
								</div>
								<div class="givef-w60">
									<b-form-input
										class="w-100"
										disabled
										placeholder="Panel Name"
										:value="
											userInfo && userInfo.username
												? formattedData(userInfo.username)
												: ''
										"
									>
									</b-form-input>
								</div>
							</div>

							<div class="d-flex givef-flex gap-2 w-100">
								<div class="w-40 giveFdbk-basic-head givef-w-100">
									Mode of Interview
								</div>
								<div class="givef-w60">
									<b-form-input
										class="w-100"
										disabled
										placeholder="Mode of Interview"
										value="Face to Face"
									>
									</b-form-input>
								</div>
							</div>
						</div>
					</section>
					<template v-if="selectedValue != 'DNA'">
						<section
							class="mt-3 givefdbck-blue-containers"
							v-for="(skill, i) in formData.skills"
							:key="i"
						>
							<div class="exptp-inner-containers-head w-100">
								{{ skill.name }}
							</div>
							<div
								v-if="skill.markingType == 'rating'"
								class="d-flex align-items-center"
							>
								<div class="newInt-inner-containers-subhead">
									Rating:<span v-if="skill.mandatory" class="asterik">*</span>
								</div>
								<div class="extpanelist-rating-input">
									<b-form-rating
										variant="primary"
										class="newInt-rating p-0 w-25 ml-2"
										:class="{
											'newInt-rating-error':
												$v.formData.skills.$each[i].mark.$error,
										}"
										v-model="$v.formData.skills.$each[i].mark.$model"
									></b-form-rating>
								</div>
							</div>
							<div
								v-if="skill.markingType == 'score'"
								class="d-flex align-items-center gap-3 newInt-inner-containers-subhead my-2"
							>
								<span class=""
									>Score:<span v-if="skill.mandatory" class="asterik"
										>*</span
									></span
								>
								<b-form-input
									class="score-input"
									type="number"
									@wheel.prevent
									min="0"
									max="10"
									:class="{ error: $v.formData.skills.$each[i].mark.$error }"
									v-model="$v.formData.skills.$each[i].mark.$model"
									@keydown="validateScore"
								></b-form-input>
								<span>out of 10</span>
							</div>
							<div v-if="skill.commentMode">
								<div class="newInt-inner-containers-subhead">
									Comments:<span v-if="skill.mandatory" class="asterik">*</span>
								</div>
								<b-form-textarea
									class="white-textarea mt-1"
									:class="{
										error: $v.formData.skills.$each[i].comments.$error,
									}"
									placeholder="Enter comments"
									rows="3"
									no-resize
									v-model="$v.formData.skills.$each[i].comments.$model"
								>
								</b-form-textarea>
							</div>
						</section>

						<section
							v-if="
								!dataLoading &&
								!uploadedImage &&
								((formData.hasOwnProperty('screenshot') &&
									formData.screenshot) ||
									!formData.hasOwnProperty('screenshot'))
							"
							class="mt-3 givefdbck-blue-containers"
						>
							<div
								class="exptp-inner-containers-head w-100 d-flex align-items-center"
							>
								<img
									src="../../assets/img/viewinterview/tp-cand-ss.svg"
									alt=""
									class="mr-2"
								/>
								Candidate Screenshot
							</div>

							<!-- class bind with this height 'jdkanban-disable-file' when grey cards are coming -->
							<div
								class="mt-2 relativeclass jdkanban-upload-file newUploadDoc"
								:class="{
									'newuploaderror newUploadDoc': invalidFile || maxSize,
								}"
							>
								<b-form-file
									ref="uploadFiles"
									id="feedback"
									accept="/image"
									@change="handleFileChange"
								>
								</b-form-file>
								<div
									class="d-flex align-items-center flex-column justify-content-center h-100 w-100"
								>
									<div
										id="hideinmobile"
										class="d-flex align-items-center justify-content-center h-50 w-100"
									>
										<img
											src="../../assets/img/viewinterview/manage-upload-icon.svg"
											alt=""
										/>
										<span class="newUploadDoc-innerContent-font-blk ml-2">
											Drag & Drop or
										</span>
										<span class="newUploadDoc-innerContent-font-blue ml-2">
											Browse file
										</span>
									</div>
									<div
										class="d-flex align-items-center kanban-upload-failed-text"
										v-if="invalidFile || maxSize"
									>
										<div>
											<img
												src="../../assets/newdesign/jdprogress/uploadfailed.svg"
												alt=""
											/>
										</div>
										<div class="ml-1">Upload Failed</div>
									</div>

									<div
										id="hideinlaptop"
										class="d-flex align-items-center justify-content-between h-100 w-100"
									>
										<div>
											<div class="asp-small-grey-txt-2">Upload File</div>
											<div class="mobjd-light-txt mt-1">
												(.png, .jpg. jpeg) max 2 mb
											</div>
										</div>
										<div class="d-flex align-items-center">
											<div class="asp-vertical-line mr-2"></div>
											<div>
												<img
													src="../../assets/newdesign/jdprogress/mobjdprog/upload.svg"
													alt=""
												/>
											</div>
										</div>
									</div>
									<!-- <div v-else class="fam-lato fs-13 fw-L text-5e5e5e w-100 h-100">
						<img class="w-100 h-100" :src="uploadedImage" />
					</div> -->

									<!-- <div
							v-if="uploadFailed"
							class="d-flex align-items-center kanban-upload-failed-text"
						>
							<div>
								<img
									src="../../assets/img/viewinterview/uploadfailed.svg"
									alt=""
								/>
							</div>
							<div class="ml-1">Upload Failed</div>
						</div> -->
								</div>
							</div>
							<div class="kanban-fdbck-validation-msg mt-1" v-if="maxSize">
								File limit Exceeded
							</div>
							<div class="kanban-fdbck-validation-msg mt-1" v-if="invalidFile">
								File type Invalid
							</div>
						</section>
						<section
							v-else-if="uploadedImage"
							class="mt-3 givefdbck-blue-containers"
						>
							<div class="d-flex align-items-center justify-content-between">
								<div class="exptp-inner-containers-head">
									<img
										src="../../assets/newdesign/jdprogress/pssicon.svg"
										class="mr-2"
										alt=""
									/>
									Candidate Screenshot<span
										v-if="
											formData.hasOwnProperty('screenshot') &&
											formData.screenshot
										"
										class="asterik"
										>*</span
									>
								</div>
								<div class="d-flex">
									<div class="pointer position-relative ucdSelDocFile mr-1">
										<img
											src="../../assets/newdesign/jdprogress/replace.svg"
											alt=""
										/>

										<b-form-file
											@input="handleFileChange"
											v-model="uploadedImage"
											ref="excel-upload-input"
											class="mb-2"
											accept=".jpeg,.png"
										></b-form-file>
									</div>
									<img
										src="../../assets/newdesign/jdprogress/x-close.svg"
										alt=""
										class="pointer"
									/>
								</div>
							</div>
							<div class="mt-2 extp-cand-ssbox">
								<img
									:src="uploadedImage"
									class="w-100 h-100 overflow-hidden"
									alt=""
								/>
							</div>
						</section>
					</template>
				</div>
			</div>
			<footer
				class="candash-modal-footer bg-white d-flex align-items-center justify-content-end"
			>
				<b-button class="candash-cancelBtn pointer mr-3" @click="backToKanban()"
					>Cancel</b-button
				>
				<div class="position-relative">
					<b-button
						class="candash-addBtn pointer"
						:class="!loading ? 'pointer' : 'opac-5'"
						@click="loading ? '' : submitFeedback()"
					>
						<span :class="loading ? 'invisible' : 'pointer'">Send</span>
					</b-button>
					<div v-if="loading" class="loader-pos-new">
						<Loader />
					</div>
				</div>
			</footer>
		</main>
	</main>
</template>

<script>
import {
	formattedData,
	formattedDate,
} from "@/components/PanelDasboard/panelHelpers";
import { getfeedbackforms, postFeedBackForm } from "@/utils/apiFunctions";
import {
	required,
	maxValue,
	minValue,
	requiredIf,
} from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
import Loader from "../../components/fixedcomponents/Loader.vue";
import toast from "@/components/mixin/toast";
export default {
	name: "GiveFeedback",
	data() {
		return {
			value: 4,
			formData: {
				basicInfo: {},
				recommendationComments: "",
				skills: [{ comments: "" }, { comments: "" }, { comments: "" }],
			},
			dataLoading: false,
			selectedValue: null,
			maxSize: false,
			invalidFile: false,
			uploadedImage: null,
			uploadFailed: false,
			isLaptop: false,
			loading: false,
		};
	},
	mixins: [toast],
	components: { Loader },
	validations() {
		const vm = this;
		return {
			selectedValue: {
				required,
			},
			formData: {
				recommendationComments: {
					required,
				},

				skills: {
					$each: {
						comments: {
							required: requiredIf(
								(obj) =>
									vm.selectedValue != "DNA" && obj.commentMode && obj.mandatory
							),
						},
						mark: {
							required: requiredIf(
								(obj) =>
									vm.selectedValue != "DNA" &&
									obj.markingType != "" &&
									obj.mandatory
							),
							maxValue: maxValue(10),
							minValue: minValue(0),
						},
					},
				},
			},
		};
	},
	created() {
		this.checkScreenSize();
		this.getFeedBackTemplate();
	},
	watch: {
		selectedValue(val) {
			if (val == "DNA") {
				this.resetSkillData();
			}
		},
	},
	computed: {
		formattedDate() {
			return new Date().toLocaleDateString("en-GB");
		},
		...mapGetters("candidateVUEX", {
			basicInfo: "getFeedbackData",
			candidateInfo: "getcandidateInfo",
		}),
		...mapGetters("userVUEX", {
			userInfo: "getUserInfo",
		}),
	},
	methods: {
		evaluationDate() {
			return formattedDate(this.formData.basicInfo.evalDate);
		},
		formattedData(data) {
			return formattedData(data);
		},
		resetSkillData() {
			if (this.formData.skills) {
				this.formData.skills.map((obj) => {
					obj.comments = "";
					obj.mark = "";
					return obj;
				});
			}
			this.formData.screenshotMedia = "";
		},
		checkScreenSize() {
			this.isLaptop = window.innerWidth >= 1024;
		},
		async getFeedBackTemplate() {
			this.dataLoading = true;
			let payload = {
				type: 2,
				feedbackFormID: this.basicInfo.formID,
				licenseKey: this.basicInfo.licenseKey,
			};
			const res = await getfeedbackforms(payload);
			if (res.status == 200) {
				this.formData = res.data.data;
				this.formData.basicInfo.name = this.basicInfo.name;
				this.formData.basicInfo.panel = this.userInfo.email;
				this.formData.basicInfo.evalDate = this.formattedDate;
				this.dataLoading = false;
			}
		},
		async submitFeedback() {
			try {
				this.$v.$touch();
				if (this.$v.$invalid) {
					this.errorModal("Error", "Please fill all the fields!");
					return;
				} else if (
					((this.formData.hasOwnProperty("screenshot") &&
						this.formData.screenshot) ||
						!this.formData.hasOwnProperty("screenshot")) &&
					!this.formData.screenshotMedia
				) {
					return;
				}
				this.loading = true;
				let payloadData = {};
				payloadData.licenseKey = this.formData.licenseKey;
				payloadData.name = this.formData.basicInfo.name;
				payloadData.processedBy = "CandPanel";
				payloadData.interviewID = this.basicInfo.interviewID;
				this.formData.basicInfo.modeOfInterview = payloadData.modeOfInterview =
					"f2f";
				payloadData["createdFor"] = payloadData["panelName"] =
					this.userInfo.email;
				if (this.selectedValue == "S") {
					payloadData["select"] = true;
				}
				payloadData["recruiterRemarks"] = this.formData.recommendationComments;
				payloadData.recommendation = this.selectedValue;
				payloadData.userID = payloadData.createdBy = this.candidateInfo.userID;
				let formDataVal = {};
				let finalData = {};
				if (this.selectedValue != "DNA") {
					formDataVal = { customFeedback: this.formData };
					finalData = { ...formDataVal, ...payloadData };
				} else {
					finalData = payloadData;
				}
				const formData = new FormData();
				Object.keys(finalData).forEach((key) => {
					const value = finalData[key];
					if (typeof value === "object" && value !== null) {
						formData.append(key, JSON.stringify(value)); // Convert to JSON
					} else {
						formData.append(key, value);
					}
				});
				const res = await postFeedBackForm(formData);
				if (res.status == 200) {
					this.loading = false;
					console.log(res);
					// this.successModal("Success", "FeedBack Submitted.");
					this.backToKanban(true);
				} else {
					this.loading = false;
					this.errorModal("Error", "Something went wrong!");
				}
			} catch (error) {
				this.loading = false;
				let value = error.response.data.data.Detail
					? error.response.data.data.Detail
					: "Something went wrong!";
				this.errorModal("Error", value);
			}
		},
		backToKanban(type) {
			if (this.isLaptop) {
				let typeVal = type ? true : false;
				this.$emit("fromFeedback", { submitted: typeVal });
			} else if (
				this.$route.query.from == "jobdetails" ||
				(this.$route.query.backto && this.$route.query.level)
			) {
				if (!type) {
					let queryVal = JSON.parse(JSON.stringify(this.$route.query));
					queryVal.from = queryVal.backto;
					delete queryVal.backto;
					this.$router.push({
						name: "JobDetails",
						query: queryVal,
					});
				} else if (this.$route.query.backto && this.$route.query.level) {
					this.$router.push({
						name: "PanelInterviews",
						params: {
							level: this.$route.query.level,
						},
					});
				} else {
					this.$router.push({
						name: "PanelDashboard",
					});
				}
			} else {
				this.$router.push({
					name: "PanelDashboard",
				});
			}
		},
		validateScore(event) {
			if (["e", "E", "+", "-"].includes(event.key)) {
				event.preventDefault();
			}
		},

		handleFileChange(event) {
			const file = event.target.files[0];

			this.maxSize = false;
			this.invalidFile = false;

			if (file) {
				if (file.size > 2 * 1024 * 1024) {
					this.maxSize = true;
					this.uploadedImage = null; // Reset the file if size exceeds 2MB
					return;
				}

				const validFileTypes = [
					"image/jpeg",
					"image/png",
					"image/gif",
					"image/jpg",
				];
				if (!validFileTypes.includes(file.type)) {
					this.invalidFile = true;
					this.uploadedImage = null; // Reset the file if type is invalid
					return;
				} else {
					this.maxSize = false;
					this.invalidFile = false;

					const reader = new FileReader();
					reader.onload = () => {
						this.uploadedImage = reader.result;
					};
					this.formData.screenshotMedia = file;
					reader.readAsDataURL(file);
					reader.onerror = () => {
						this.uploadFailed = true;
					};
				}
			}
		},
	},
};
</script>

<style>
.giveFdbk-head {
	font-family: "Lato", sans-serif;
	font-style: normal;
	font-weight: 500;
	font-size: 16px;
	line-height: 130%;
	color: #000000;
}

.giveFdbk-basic-head {
	font-family: "Montserrat", sans-serif;
	font-style: normal;
	font-weight: 500;
	font-size: 14px;
	line-height: 20px;
	color: #344054;
}

.recomendation-error .custom-control-label::before {
	border: 1px solid red !important;
}

.allocateradios
	.custom-radio
	.custom-control-input:checked
	~ .custom-control-label::after {
	background-image: none;
	border: 2px solid #20639b;
	border-radius: 50%;
}

.allocateradios .custom-control-input:checked ~ .custom-control-label::before {
	color: #fff;
	border-width: 4px;
	border-color: #fff;
	background-color: #20639b;
}

.allocateradios .custom-control-label {
	font-family: "Lato", sans-serif;
	font-weight: 500;
	font-size: 14px;
	color: #3a3c40;
	line-height: 24px;
}

.allocateradios .custom-control-label::before {
	border: 2px solid #20639b;
}

.allocateradios .custom-control-input[disabled] ~ .custom-control-label,
.custom-control-input:disabled ~ .custom-control-label {
	color: #3a3c40;
}

.allocateradios .custom-control-input[disabled] ~ .custom-control-label::before,
.custom-control-input:disabled ~ .custom-control-label::before {
	top: 3px;
	background-color: #ffffff;
}
.allocateradios .error .custom-control-label::before {
	border: 2px solid #eb0002;
}
.giveFdbk-textarea {
	border-radius: 8px;
	background: #fff;
	font-family: "Montserrat", sans-serif;
	font-style: normal;
	font-weight: 500;
	font-size: 14px;
	line-height: 17px;
	color: #333333;
}
.extp-basicinfomartion .form-control {
	border-radius: 8px;
}

.extp-basicinfomartion .form-control:disabled {
	background: #f6f6f6;
	box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05);
	border-radius: 8px;
	opacity: unset;
	font-family: Montserrat, sans-serif;
	font-weight: 500;
	font-size: 14px;
	color: #333;
	border: none;
}

.givefdbck-blue-containers {
	border: 1px solid hsla(0, 0%, 54.9%, 0.33);
	border-radius: 8px;
	padding: 10px;
	background: #edf4f9;
}

.givefdbck-grey-containers {
	border: 1px solid #8c8c8c54;
	border-radius: 8px;
	padding: 10px;
	background: #f6f6f6;
}
.givefdbck-blue-containers .score-input {
	width: 64px;
	border: 1px solid #d0d5dd;
	border-radius: 8px;
}

.givefdbck-blue-containers .score-input.form-control:disabled {
	cursor: not-allowed !important;
	background-color: #ffffff !important;
}
.exptp-inner-containers-head {
	font-family: "Lato", sans-serif;
	font-style: normal;
	font-weight: 700;
	font-size: 14px;
	line-height: 130%;
	color: #000;
}

.newInt-inner-containers-subhead {
	font-family: "Lato", sans-serif;
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	line-height: 130%;
	color: #444;
}

.newInt-rating.b-rating.disabled {
	background-color: unset !important;
	color: #20639b !important;
	border: none !important;
	cursor: not-allowed !important;
}

.newInt-rating.b-rating.form-control {
	background: none;
	border: none;
	/* border-radius: 0.25rem; */
}

.newInt-rating.b-rating {
	background-color: unset !important;
	color: #20639b !important;
	border: none !important;
}

.white-textarea.form-control {
	background: #fff;
	border: 1px solid #d0d5dd;
	box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05);
	border-radius: 8px;
	font-family: "Montserrat", sans-serif;
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	color: #667085;
}
.white-textarea.form-control:disabled {
	cursor: not-allowed !important;
}

.giveFdbk-overflow {
	height: calc(100vh - 230px);
	max-height: 880px;
	overflow-y: auto;
	overflow-x: hidden;
	padding: 0.5rem 1.5rem;
}

.newUploadDoc {
	background: #ffffff;
	border: 1px dashed #20639b;
	box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.17);
	border-radius: 8px;
	width: 100%;
	height: 42px;
	padding: 0px 24px;
}

.newUploadDoc .custom-file {
	position: absolute;
	left: 0px;
	top: 0px;
	width: 100%;
	height: 100%;
}

.newUploadDoc .custom-file-input {
	height: 100%;
}

.newUploadDoc .custom-file-label {
	height: 100%;
	width: 100%;
	cursor: pointer;
	opacity: 0;
}

.newUploadDoc-innerContent {
	position: absolute;
	left: 0px;
}

.newUploadDoc-innerContent-font-blk {
	font-family: "Lato", sans-serif;
	font-style: normal;
	font-weight: 500;
	font-size: 16px;
	line-height: 130%;
	color: #000000;
}

.newUploadDoc-innerContent-font-blue {
	font-family: "Lato", sans-serif;
	font-style: normal;
	font-weight: 500;
	font-size: 16px;
	line-height: 130%;
	color: #20639b;
}

.newUploadDoc {
	background: #ffffff;
	border: 1px dashed #20639b;
	box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.17);
	border-radius: 8px;
	width: 100%;
	height: 42px;
	padding: 0px 24px;
}

.newUploadDoc .custom-file {
	position: absolute;
	left: 0px;
	top: 0px;
	width: 100%;
	height: 100%;
}

.newUploadDoc .custom-file-input {
	height: 100%;
}

.newUploadDoc .custom-file-label {
	height: 100%;
	width: 100%;
	cursor: pointer;
	opacity: 0;
}

.newUploadDoc-innerContent {
	position: absolute;
	left: 0px;
}

.newUploadDoc-innerContent-font-blk {
	font-family: "Lato", sans-serif;
	font-style: normal;
	font-weight: 500;
	font-size: 16px;
	line-height: 130%;
	color: #000000;
}

.newUploadDoc-innerContent-font-blue {
	font-family: "Lato", sans-serif;
	font-style: normal;
	font-weight: 500;
	font-size: 16px;
	line-height: 130%;
	color: #20639b;
}

.jdkanban-upload-file {
	width: 100%;
	height: 101px;
}
.jdkanban-disable-file {
	width: 100%;
	height: 135px;
}

.newuploaderror {
	border: 1px dashed #eb0002;
}

.ct-table-switch .custom-control-label {
	font-family: "Montserrat", sans-serif;
	font-size: 13px;
	font-weight: 500;
	color: #344054;
}

.ct-table-switch .custom-control-label::before {
	width: 24px !important;
	height: 13px;
	border: 1px solid #8c8c8c !important;
	font-family: "Montserrat", sans-serif;
	font-size: 13px;
	font-weight: 500;
	color: #344054;
}

.ct-table-switch .custom-control-label::after {
	border: 1.5px solid #8c8c8c;
	background-color: transparent !important;
	height: 7px !important;
	width: 7px !important;
	left: -32px !important;
	top: 7px !important;
}

.ct-table-switch .custom-control-input:checked ~ .custom-control-label::before {
	color: #fff;
	border-color: #20639b !important;
	background-color: #20639b !important;
}

.ct-table-switch .custom-control-input:checked ~ .custom-control-label::after {
	border: 2px solid #fff !important;
	background-color: #20639b !important;
	left: -34px !important;
}

.ct-table-switch
	.custom-control-input:disabled
	~ .custom-control-label::before {
	top: 4px;
	background-color: #f6f9fb;
}

.apply-font {
	font-family: "Lato", sans-serif;
	font-style: normal;
	font-weight: 500;
	font-size: 14px;
	line-height: 17px;
	color: #3a3c40;
}
.giveFdbk-textarea-head {
	font-family: "Montserrat", sans-serif;
	font-weight: 500;
	font-size: 13px;
	letter-spacing: 0%;
	color: #344054;
}
.form-control:focus {
	border-color: unset;
	box-shadow: unset;
	border: 1px solid #d0d5dd;
}
.givef-flex {
	align-items: center;
}
.givef-w60 {
	width: 60%;
}
.givef-gap {
	column-gap: 1.5rem;
	row-gap: 0.3rem;
}
.exptp-inner-containers-head {
	font-family: "Lato", sans-serif;
	font-style: normal;
	font-weight: bold;
	font-size: 14px;
	line-height: 130%;
	color: #000000;
}
.kanban-upload-failed-text {
	text-align: center;
	top: 60px;
	color: #eb0002;
	font-family: "Lato", sans-serif;
	font-size: 16px;
	font-weight: 500;
}
.kanban-fdbck-validation-msg {
	font-family: "Montserrat", sans-serif;
	font-style: normal;
	font-weight: 500;
	font-size: 11px;
	color: #eb0002;
}
.extp-cand-ssbox {
	height: 186px;
	border-radius: 28px;
	overflow: hidden;
}
/* .newInt-rating-error .b-rating {
	background-color: unset !important;
	border: #eb0002 !important;
} */
.newInt-rating.newInt-rating-error .text-primary {
	color: #eb0002 !important;
}
@media (min-width: 1029px) {
	.formobile .become-panel-container {
		background-color: unset;
		height: unset;
		padding: unset;
		top: unset;
		position: unset;
		display: unset;
		flex-direction: column;
	}

	.formobile .mobjd-applied-top {
		height: unset;
		overflow-y: unset;
		overflow-x: unset;
	}

	.formobile .mobjd-jobdetails {
		background-color: unset;
		border-radius: unset;
		width: unset;
		padding: unset;
	}
	.formobile .candash-modal-footer {
		border-radius: 0 0 12px 12px;
	}
}
@media (max-width: 1028px) {
	.givef-w-100 {
		width: 100%;
	}
	.giveFdbk-overflow {
		height: 100%;
		max-height: unset;
		overflow-x: hidden;
		padding: 0;
	}
	.givef-flex {
		flex-direction: column;
		align-items: flex-start;
	}
	.givef-w60 {
		width: 100%;
	}
	.jdkanban-upload-file {
		width: 100%;
		height: 65px;
		padding: 0 15px !important;
		border: none;
		box-shadow: none;
	}
	.givefdbck-blue-containers {
		border: 1px solid #eaeaea;
	}

	.givefdbck-grey-containers {
		border: 1px solid #eaeaea;
	}
}
</style>
